import React from 'react'

import Error from 'next/error'

import MainLayout from 'components/Layout/Main'
import Error4XX from 'pages/4XX'
import Error5XX from 'pages/5XX'
import LogService from 'services/LogService'

/** @type {import("./_error").default} */
const GetAppError = ({ asPath, statusCode, hasGetInitialPropsRun, err }) => {
  if (!hasGetInitialPropsRun && err) {
    // getInitialProps is not called in case of
    // https://github.com/zeit/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    LogService.error(err, asPath || '404')
  }
  return statusCode >= 400 && statusCode < 500 ? <Error4XX /> : <Error5XX />
}

GetAppError.getInitialProps = async ({ res, err, asPath }) => {
  const errorInitialProps = await Error.getInitialProps({ res, err })

  // Workaround for https://github.com/zeit/next.js/issues/8592, mark when
  // getInitialProps has run
  errorInitialProps.hasGetInitialPropsRun = true
  if (res) {
    // Running on the server, the response object is available.
    //
    // Next.js will pass an err on the server if a page's `getInitialProps`
    // threw or returned a Promise that rejected

    if (res.statusCode < 500) {
      // Opinionated: do not record an exception in Sentry on 3xx y 4xx statues
      return { asPath, statusCode: res.statusCode }
    }

    if (err) {
      LogService.error(err, asPath)

      return errorInitialProps
    }
  }

  if (res && res.statusCode !== undefined) {
    // If this point is reached, getInitialProps was called without any
    // information about what the error might be. This is unexpected and may
    // indicate a bug introduced in Next.js, so record it in Sentry
    LogService.error(new Error(`_error.js getInitialProps missing data at path: ${asPath}`), asPath)
  }
  return errorInitialProps
}

GetAppError.Layout = MainLayout

export default GetAppError
